/* HASAD — global.js
   Vanilla JS, no dependencies. Drawers, smart header, cart AJAX,
   scroll reveals, product form, sticky ATC, quantity steppers. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Utilities ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var fmt = window.Hasad && window.Hasad.moneyFormat ? window.Hasad.moneyFormat : 'LE {{amount}}';
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    amount = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  function toast(msg) {
    var el = $('.toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 3200);
  }

  /* ---------- Scroll reveals ---------- */
  function initReveals() {
    var els = $$('.reveal');
    if (!els.length || reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var group = el.closest('[data-reveal-group]');
          if (group) {
            var siblings = $$('.reveal', group);
            var idx = siblings.indexOf(el);
            el.style.transitionDelay = (idx * 60) + 'ms';
          }
          el.classList.add('is-visible');
          io.unobserve(el);
        }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Smart header ---------- */
  function initHeader() {
    var header = $('.site-header');
    if (!header) return;
    var lastY = window.scrollY;
    var transparent = header.classList.contains('site-header--transparent');
    function onScroll() {
      var y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 40);
      if (transparent) header.classList.toggle('is-solid', y > 40);
      if (header.dataset.sticky === 'smart') {
        if (y > lastY && y > 160) header.classList.add('is-hidden');
        else header.classList.remove('is-hidden');
      }
      lastY = y;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    // Close open mega menus on outside click / Esc
    document.addEventListener('click', function (e) {
      $$('.mega[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') $$('.mega[open]').forEach(function (d) { d.removeAttribute('open'); });
    });
  }

  /* ---------- Drawers ---------- */
  var focusReturn = null;
  function openDrawer(id) {
    var drawer = document.getElementById(id);
    var scrim = $('.drawer-scrim');
    if (!drawer) return;
    focusReturn = document.activeElement;
    drawer.classList.add('is-open');
    if (scrim) scrim.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    drawer.removeAttribute('aria-hidden');
    var focusable = drawer.querySelector('button, a, input, [tabindex]');
    if (focusable) focusable.focus();
    drawer.addEventListener('keydown', trapFocus);
  }
  function closeDrawers() {
    $$('.drawer.is-open').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      d.removeEventListener('keydown', trapFocus);
    });
    var scrim = $('.drawer-scrim');
    if (scrim) scrim.classList.remove('is-open');
    document.body.style.overflow = '';
    if (focusReturn) { focusReturn.focus(); focusReturn = null; }
  }
  function trapFocus(e) {
    if (e.key !== 'Tab') return;
    var drawer = e.currentTarget;
    var items = $$('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])', drawer)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function initDrawers() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-drawer-open]');
      if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open')); return; }
      if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('drawer-scrim')) {
        closeDrawers();
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });
  }

  /* ---------- Cart ---------- */
  function refreshCartDrawer(openAfter) {
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('#CartDrawerContent');
        var current = document.getElementById('CartDrawerContent');
        if (fresh && current) current.replaceWith(fresh);
        var freshCount = tmp.querySelector('[data-cart-count]');
        $$('[data-cart-count]').forEach(function (el) {
          if (!el.closest('#CartDrawerContent') && freshCount) {
            el.textContent = freshCount.textContent;
            el.classList.add('is-pop');
            setTimeout(function () { el.classList.remove('is-pop'); }, 350);
          }
        });
        if (openAfter) openDrawer('CartDrawer');
      });
  }

  function addToCart(form, button) {
    var original = button ? button.textContent : '';
    if (button) { button.setAttribute('aria-disabled', 'true'); button.textContent = button.dataset.addingText || 'Adding…'; }
    var body = new FormData(form);
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST', body: body, headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.json.description || res.json.message || 'Could not add to basket'); return; }
        if (button) button.textContent = button.dataset.addedText || 'Added ✓';
        return refreshCartDrawer(true);
      })
      .catch(function () { toast('Could not add to basket — please try again.'); })
      .finally(function () {
        if (button) setTimeout(function () {
          button.textContent = original; button.removeAttribute('aria-disabled');
        }, 1200);
      });
  }

  function addBundleToCart(button) {
    var items;
    try { items = JSON.parse(button.dataset.bundleItems || '[]'); } catch (err) { items = []; }
    if (!items.length) return;
    var original = button.textContent;
    button.setAttribute('aria-disabled', 'true');
    button.textContent = button.dataset.addingText || 'Adding…';
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.json.description || res.json.message || 'Could not add the bundle to your basket'); return; }
        button.textContent = button.dataset.addedText || 'Added ✓';
        return refreshCartDrawer(true);
      })
      .catch(function () { toast('Could not add the bundle — please try again.'); })
      .finally(function () {
        setTimeout(function () {
          button.textContent = original; button.removeAttribute('aria-disabled');
        }, 1200);
      });
  }

  function changeCartQty(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function () {
      if ($('#CartDrawer.is-open')) return refreshCartDrawer(false);
      // On the cart page, re-render by reload (simplest reliable path)
      if (document.body.classList.contains('template-cart')) window.location.reload();
      else return refreshCartDrawer(false);
    });
  }

  function initCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-ajax-cart]');
      if (!form) return;
      e.preventDefault();
      addToCart(form, form.querySelector('[data-atc]'));
    });
    document.addEventListener('click', function (e) {
      var bundleBtn = e.target.closest('[data-bundle-add]');
      if (bundleBtn) { addBundleToCart(bundleBtn); return; }
      var removeBtn = e.target.closest('[data-cart-remove]');
      if (removeBtn) {
        e.preventDefault();
        changeCartQty(parseInt(removeBtn.dataset.line, 10), 0);
        return;
      }
      var qtyBtn = e.target.closest('[data-qty-change]');
      if (qtyBtn) {
        var wrap = qtyBtn.closest('.qty');
        var input = wrap.querySelector('.qty__input');
        var val = Math.max(parseInt(input.min || '0', 10), (parseInt(input.value, 10) || 0) + parseInt(qtyBtn.dataset.qtyChange, 10));
        input.value = val;
        if (input.dataset.line) changeCartQty(parseInt(input.dataset.line, 10), val);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    document.addEventListener('change', function (e) {
      var input = e.target.closest('.qty__input[data-line]');
      if (input && !e.target.closest('[data-qty-change]')) {
        changeCartQty(parseInt(input.dataset.line, 10), Math.max(0, parseInt(input.value, 10) || 0));
      }
    });
  }

  /* ---------- Product form (variant selection) ---------- */
  function initProductForms() {
    $$('[data-product-form]').forEach(function (wrap) {
      var json = $('[data-product-json]', wrap);
      if (!json) return;
      var product;
      try { product = JSON.parse(json.textContent); } catch (err) { return; }
      var idInput = $('input[name="id"]', wrap);
      var priceEl = $('[data-price]', wrap);
      var atc = $('[data-atc]', wrap);

      function currentOptions() {
        return $$('.variant-pills', wrap).map(function (group) {
          var checked = $('input:checked', group);
          return checked ? checked.value : null;
        });
      }
      function findVariant(opts) {
        return product.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
      }
      wrap.addEventListener('change', function (e) {
        if (!e.target.matches('.variant-pills input')) return;
        var variant = findVariant(currentOptions());
        if (!variant) return;
        idInput.value = variant.id;
        if (priceEl) {
          var html = '<span>' + formatMoney(variant.price) + '</span>';
          if (variant.compare_at_price > variant.price) {
            html += ' <s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>';
          }
          priceEl.innerHTML = html;
        }
        if (atc) {
          if (variant.available) { atc.removeAttribute('disabled'); atc.textContent = atc.dataset.addText || 'Add to cart'; }
          else { atc.setAttribute('disabled', ''); atc.textContent = atc.dataset.soldText || 'Sold out'; }
        }
        var backInStock = $('[data-back-in-stock]', wrap.closest('.pdp') || wrap);
        if (backInStock) {
          backInStock.hidden = !!variant.available;
          var note = $('[data-back-in-stock-note]', backInStock);
          if (note) note.value = 'Wants back in stock: ' + product.title + ' (' + variant.title + ')';
        }
        // Variant-linked media
        if (variant.featured_media) {
          var thumb = $('[data-media-id="' + variant.featured_media.id + '"]', wrap.closest('.pdp') || document);
          if (thumb) thumb.click();
        }
        // Update URL
        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url.toString());
        }
      });
    });
  }

  /* ---------- PDP gallery ---------- */
  function initGallery() {
    var gallery = $('[data-gallery]');
    if (!gallery) return;
    var main = $('[data-gallery-main] img', gallery);
    gallery.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-media-id]');
      if (!btn || !main) return;
      main.src = btn.dataset.src;
      main.srcset = btn.dataset.srcset || '';
      main.alt = ($('img', btn) || {}).alt || '';
      $$('[data-media-id]', gallery).forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  }

  /* ---------- Quick view ---------- */
  var quickViewCache = {};
  var quickViewFocusReturn = null;

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function quickViewSkeleton() {
    return '<div class="qv-modal__skeleton">' +
      '<div class="skeleton" style="aspect-ratio:4/5;border-radius:var(--radius-feature);"></div>' +
      '<div>' +
        '<div class="skeleton" style="height:2rem;width:70%;margin-bottom:1rem;"></div>' +
        '<div class="skeleton" style="height:1.2rem;width:35%;margin-bottom:2rem;"></div>' +
        '<div class="skeleton" style="height:3rem;width:100%;margin-bottom:1rem;"></div>' +
        '<div class="skeleton" style="height:3rem;width:60%;"></div>' +
      '</div>' +
    '</div>';
  }

  function quickViewPriceHtml(variant) {
    if (!variant) return '';
    var html = '<span class="price tnum"><span>' + formatMoney(variant.price) + '</span>';
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      html += ' <s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>';
    }
    html += '</span>';
    return html;
  }

  function quickViewOptionGroups(product) {
    return (product.options || []).map(function (name, i) {
      var seen = [], values = [];
      product.variants.forEach(function (v) {
        var val = v.options[i];
        if (val && seen.indexOf(val) === -1) { seen.push(val); values.push(val); }
      });
      return { name: name, index: i, values: values };
    });
  }

  function quickViewFindVariant(product, selected) {
    return product.variants.filter(function (v) {
      return v.options.every(function (o, i) { return selected[i] == null || o === selected[i]; });
    })[0];
  }

  function renderQuickView(product) {
    var mainImg = product.featured_image || (product.images && product.images[0]) || '';
    var thumbs = (product.images || []).slice(0, 6);
    var groups = quickViewOptionGroups(product);
    var current = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
    var selected = current ? current.options.slice() : [];

    var thumbsHtml = thumbs.length > 1 ? '<div class="qv-modal__thumbs">' + thumbs.map(function (src) {
      return '<button type="button" data-qv-thumb data-src="' + escapeHtml(src) + '"' +
        (src === mainImg ? ' class="is-active"' : '') + '><img src="' + escapeHtml(src) + '" alt="" loading="lazy"></button>';
    }).join('') + '</div>' : '';

    var optionsHtml = groups.map(function (group) {
      return '<fieldset style="border:none;padding:0;margin:0 0 12px;">' +
        '<legend class="field__label">' + escapeHtml(group.name) + '</legend>' +
        '<div class="variant-pills" data-qv-option="' + group.index + '">' +
        group.values.map(function (val, vi) {
          var id = 'QvOpt' + group.index + '_' + vi;
          var checked = selected[group.index] === val ? ' checked' : '';
          return '<input type="radio" id="' + id + '" name="qv-option-' + group.index + '" value="' + escapeHtml(val) + '"' + checked + '>' +
                 '<label for="' + id + '">' + escapeHtml(val) + '</label>';
        }).join('') +
        '</div></fieldset>';
    }).join('');

    return '<div class="qv-modal__grid">' +
      '<div>' +
        '<div class="media media--45 media--r20" data-qv-main><img src="' + escapeHtml(mainImg) + '" alt="' + escapeHtml(product.title) + '" width="700" height="875" loading="lazy"></div>' +
        thumbsHtml +
      '</div>' +
      '<div>' +
        '<h2 class="heading-m" style="margin-bottom:.5rem;">' + escapeHtml(product.title) + '</h2>' +
        '<div data-qv-price style="margin-bottom:1.25rem;">' + quickViewPriceHtml(current) + '</div>' +
        optionsHtml +
        '<div class="buy-row" style="margin-top:.5rem;">' +
          '<div class="qty">' +
            '<button class="qty__btn" type="button" data-qv-qty="-1" aria-label="Decrease quantity">−</button>' +
            '<input class="qty__input" type="number" id="QvQty" value="1" min="1" aria-label="Quantity">' +
            '<button class="qty__btn" type="button" data-qv-qty="1" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<button class="btn btn--primary" type="button" data-qv-atc data-variant-id="' + (current ? current.id : '') + '"' +
            (current && current.available ? '' : ' disabled') +
            ' data-adding-text="Adding…" data-added-text="Added ✓">' +
            (current && current.available ? 'Add to cart' : 'Sold out') + '</button>' +
        '</div>' +
        '<a class="btn btn--ghost" href="' + product.url + '" style="margin-top:.85rem;display:inline-block;">View full details</a>' +
      '</div>' +
    '</div>';
  }

  function quickViewAddToCart(button) {
    var variantId = button.dataset.variantId;
    if (!variantId) return;
    var qtyInput = $('#QvQty');
    var qty = Math.max(1, parseInt(qtyInput ? qtyInput.value : 1, 10) || 1);
    var original = button.textContent;
    button.setAttribute('aria-disabled', 'true');
    button.textContent = button.dataset.addingText || 'Adding…';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.json.description || res.json.message || 'Could not add to basket'); return; }
        button.textContent = button.dataset.addedText || 'Added ✓';
        closeQuickView();
        return refreshCartDrawer(true);
      })
      .catch(function () { toast('Could not add to basket — please try again.'); })
      .finally(function () {
        setTimeout(function () { button.textContent = original; button.removeAttribute('aria-disabled'); }, 1200);
      });
  }

  function openQuickView(handle) {
    var modal = $('#QuickViewModal');
    var scrim = $('[data-quick-view-scrim]');
    var body = $('#QuickViewBody');
    if (!modal || !body) return;
    quickViewFocusReturn = document.activeElement;
    body.innerHTML = quickViewSkeleton();
    body._product = null;
    modal.classList.add('is-open');
    modal.removeAttribute('aria-hidden');
    if (scrim) scrim.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var request = quickViewCache[handle]
      ? Promise.resolve(quickViewCache[handle])
      : fetch(root + 'products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) { quickViewCache[handle] = p; return p; });

    request.then(function (product) {
      body.innerHTML = renderQuickView(product);
      body._product = product;
      var closeBtn = $('.qv-modal__close');
      if (closeBtn) closeBtn.focus();
    }).catch(function () {
      body.innerHTML = '<p class="form-message form-message--error">Could not load this product. <a href="/products/' + handle + '">View it on its own page</a>.</p>';
    });
  }

  function closeQuickView() {
    var modal = $('#QuickViewModal');
    var scrim = $('[data-quick-view-scrim]');
    if (!modal || !modal.classList.contains('is-open')) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    if (scrim) scrim.classList.remove('is-open');
    if (!$('.drawer.is-open')) document.body.style.overflow = '';
    if (quickViewFocusReturn) { quickViewFocusReturn.focus(); quickViewFocusReturn = null; }
  }

  function initQuickView() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-quick-view]');
      if (opener) { e.preventDefault(); openQuickView(opener.getAttribute('data-quick-view')); return; }

      if (e.target.closest('[data-quick-view-close]') || e.target.matches('[data-quick-view-scrim]')) {
        closeQuickView();
        return;
      }

      var body = $('#QuickViewBody');
      if (!body || !body.contains(e.target) || !body._product) return;

      var thumb = e.target.closest('[data-qv-thumb]');
      if (thumb) {
        var main = $('[data-qv-main] img', body);
        if (main) main.src = thumb.dataset.src;
        $$('[data-qv-thumb]', body).forEach(function (b) { b.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        return;
      }

      var qtyBtn = e.target.closest('[data-qv-qty]');
      if (qtyBtn) {
        var input = $('#QvQty', body);
        var val = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(qtyBtn.dataset.qvQty, 10));
        input.value = val;
        return;
      }

      var atc = e.target.closest('[data-qv-atc]');
      if (atc && !atc.hasAttribute('disabled')) { quickViewAddToCart(atc); return; }
    });

    document.addEventListener('change', function (e) {
      if (!e.target.matches('.variant-pills input')) return;
      var body = $('#QuickViewBody');
      if (!body || !body.contains(e.target) || !body._product) return;
      var product = body._product;
      var selected = $$('.variant-pills', body).map(function (group) {
        var checked = $('input:checked', group);
        return checked ? checked.value : null;
      });
      var variant = quickViewFindVariant(product, selected);
      if (!variant) return;
      var priceEl = $('[data-qv-price]', body);
      if (priceEl) priceEl.innerHTML = quickViewPriceHtml(variant);
      var atc = $('[data-qv-atc]', body);
      if (atc) {
        atc.dataset.variantId = variant.id;
        if (variant.available) { atc.removeAttribute('disabled'); atc.textContent = 'Add to cart'; }
        else { atc.setAttribute('disabled', ''); atc.textContent = 'Sold out'; }
      }
      if (variant.featured_image) {
        var main = $('[data-qv-main] img', body);
        if (main) main.src = variant.featured_image.src || variant.featured_image;
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeQuickView();
    });
  }

  /* ---------- Sticky ATC ---------- */
  function initStickyAtc() {
    var bar = $('.sticky-atc');
    var anchor = $('[data-atc-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var footer = $('.site-footer');
    var anchorOut = false, footerIn = false;
    function update() { bar.classList.toggle('is-visible', anchorOut && !footerIn); }
    new IntersectionObserver(function (entries) {
      anchorOut = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      update();
    }).observe(anchor);
    if (footer) new IntersectionObserver(function (entries) {
      footerIn = entries[0].isIntersecting; update();
    }).observe(footer);
    bar.addEventListener('click', function (e) {
      if (e.target.closest('[data-scroll-to-buy]')) {
        e.preventDefault();
        anchor.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      }
    });
  }

  /* ---------- Announcement dismiss ---------- */
  function initAnnouncement() {
    var bar = $('.announcement-section');
    if (!bar) return;
    try {
      if (localStorage.getItem('hasad-announcement-dismissed') === bar.dataset.message) { bar.remove(); return; }
    } catch (err) { /* private mode */ }
    bar.addEventListener('click', function (e) {
      if (!e.target.closest('.announcement__close')) return;
      try { localStorage.setItem('hasad-announcement-dismissed', bar.dataset.message); } catch (err) {}
      bar.remove();
    });

    var msgs = $$('.announcement__msg', bar);
    if (msgs.length > 1 && !reduceMotion) {
      var seconds = parseInt(bar.dataset.rotate, 10) || 6;
      var i = 0;
      setInterval(function () {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, seconds * 1000);
    }
  }

  /* ---------- Collection filtering (AJAX) ---------- */
  /* ---------- Predictive search ---------- */
  function predictiveSearchImage(item) {
    var img = item.featured_image || item.image;
    if (!img) return '';
    return img.url || img.src || (typeof img === 'string' ? img : '');
  }

  function predictiveSearchGroup(label, items, kind) {
    if (!items || !items.length) return '';
    var rows = items.map(function (item) {
      var img = predictiveSearchImage(item);
      var priceHtml = kind === 'product' && item.price ? '<div class="predictive-search__item-price tnum">' + escapeHtml(item.price) + '</div>' : '';
      return '<a class="predictive-search__item" href="' + escapeHtml(item.url) + '">' +
        (img ? '<img src="' + escapeHtml(img) + '" alt="" loading="lazy">' : '') +
        '<span><span class="predictive-search__item-title">' + escapeHtml(item.title) + '</span>' + priceHtml + '</span>' +
      '</a>';
    }).join('');
    return '<div class="predictive-search__group"><p class="predictive-search__label">' + label + '</p>' + rows + '</div>';
  }

  function initPredictiveSearch() {
    var input = $('[data-predictive-search-input]');
    var results = $('[data-predictive-search-results]');
    if (!input || !results) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var cache = {};
    var t, controller;

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(t);
      if (q.length < 2) { results.innerHTML = ''; return; }
      t = setTimeout(function () { runPredictiveSearch(q); }, 200);
    });

    function runPredictiveSearch(q) {
      if (cache[q]) { renderResults(q, cache[q]); return; }
      if (controller) controller.abort();
      controller = ('AbortController' in window) ? new AbortController() : null;
      var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,article,query&resources[limit]=4&resources[options][unavailable_products]=last';
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var res = (data.resources && data.resources.results) || {};
          cache[q] = res;
          renderResults(q, res);
        })
        .catch(function (err) { if (err.name !== 'AbortError') results.innerHTML = ''; });
    }

    function renderResults(q, res) {
      var safeQ = escapeHtml(q);
      var html =
        predictiveSearchGroup('Products', res.products, 'product') +
        predictiveSearchGroup('Collections', res.collections) +
        predictiveSearchGroup('Recipes', res.articles);
      if (!html) {
        html = '<p class="predictive-search__empty">No results for &ldquo;' + safeQ + '&rdquo;.</p>';
      }
      html += '<a class="btn btn--ghost predictive-search__more" href="/search?q=' + encodeURIComponent(q) + '">See all results for &ldquo;' + safeQ + '&rdquo;</a>';
      results.innerHTML = html;
    }
  }

  function initFacets() {
    var form = $('#FacetsForm');
    if (!form) return;
    var grid = $('#ProductGridContainer');
    var t;
    // Listen at document level: filter-drawer inputs and the sort select are
    // associated via form="FacetsForm" but live outside the form element.
    document.addEventListener('change', function (e) {
      if (e.target.form !== form && !form.contains(e.target)) return;
      clearTimeout(t);
      t = setTimeout(function () {
        var params = new URLSearchParams(new FormData(form));
        var url = window.location.pathname + '?' + params.toString();
        if (grid) grid.style.opacity = '.4';
        fetch(url + '&section_id=main-collection')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            var fresh = tmp.querySelector('#ProductGridContainer');
            if (fresh && grid) { grid.replaceWith(fresh); grid = fresh; }
            history.replaceState({}, '', url);
            initReveals();
          })
          .finally(function () { var g = $('#ProductGridContainer'); if (g) g.style.opacity = ''; });
      }, 250);
    });
  }

  /* ---------- Recipes ----------
     Shared by the Recipe showcase and Recipe grid sections. Each "shop" is a
     [data-rcp-shop] wrapper holding [data-rcp-product] cards; deselecting a
     card updates the running total and rewrites the payload on the
     [data-bundle-add] button, so adding everything stays a single request. */
  function syncRecipeShop(shop) {
    var addBtn = $('[data-rcp-add]', shop);
    var totalEl = $('[data-rcp-total]', shop);
    var items = [];
    var total = 0;

    $$('[data-rcp-product]', shop).forEach(function (card) {
      if (card.dataset.available !== 'true') return;
      var toggle = $('[data-rcp-toggle]', card);
      if (toggle && toggle.getAttribute('aria-pressed') !== 'true') return;
      var qty = parseInt(card.dataset.quantity, 10) || 1;
      items.push({ id: parseInt(card.dataset.variantId, 10), quantity: qty });
      total += (parseInt(card.dataset.price, 10) || 0) * qty;
    });

    if (totalEl) totalEl.textContent = formatMoney(total);

    if (addBtn) {
      addBtn.dataset.bundleItems = JSON.stringify(items);
      var tpl = addBtn.dataset.labelTemplate || '';
      if (tpl.indexOf('[count]') !== -1) addBtn.textContent = tpl.replace('[count]', items.length);
      if (items.length) addBtn.removeAttribute('disabled');
      else addBtn.setAttribute('disabled', 'disabled');
    }
  }

  var recipeLightbox = null, recipeTiles = [], recipeIndex = 0, recipeLastFocus = null;

  function buildRecipeLightbox() {
    if (recipeLightbox) return recipeLightbox;
    var lb = document.createElement('div');
    lb.className = 'rcp-lb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.innerHTML =
      '<button class="rcp-lb__close" type="button" data-rcp-lb-close aria-label="Close">' +
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
      '<button class="rcp-lb__nav rcp-lb__nav--prev" type="button" data-rcp-lb-step="-1" aria-label="Previous">' +
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 5-7 7 7 7"/></svg></button>' +
      '<figure class="rcp-lb__figure"><img alt=""><figcaption class="rcp-lb__caption"></figcaption></figure>' +
      '<button class="rcp-lb__nav rcp-lb__nav--next" type="button" data-rcp-lb-step="1" aria-label="Next">' +
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 5 7 7-7 7"/></svg></button>';
    document.body.appendChild(lb);
    lb.addEventListener('click', function (e) {
      if (e.target.closest('[data-rcp-lb-close]') || e.target === lb) { closeRecipeLightbox(); return; }
      var step = e.target.closest('[data-rcp-lb-step]');
      if (step) showRecipeLightbox(recipeIndex + parseInt(step.dataset.rcpLbStep, 10));
    });
    recipeLightbox = lb;
    return lb;
  }

  function showRecipeLightbox(index) {
    if (!recipeTiles.length) return;
    recipeIndex = (index + recipeTiles.length) % recipeTiles.length;
    var tile = recipeTiles[recipeIndex];
    var img = $('img', recipeLightbox);
    var cap = $('.rcp-lb__caption', recipeLightbox);
    img.src = tile.dataset.full;
    img.alt = tile.dataset.caption || '';
    cap.textContent = tile.dataset.caption || '';
    cap.hidden = !tile.dataset.caption;
    $$('.rcp-lb__nav', recipeLightbox).forEach(function (b) { b.hidden = recipeTiles.length < 2; });
  }

  function openRecipeLightbox(tile) {
    var group = tile.closest('[data-rcp-lightbox]');
    recipeTiles = $$('[data-rcp-tile]', group);
    recipeLastFocus = document.activeElement;
    buildRecipeLightbox();
    showRecipeLightbox(recipeTiles.indexOf(tile));
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () { recipeLightbox.classList.add('is-open'); });
    $('[data-rcp-lb-close]', recipeLightbox).focus();
  }

  function closeRecipeLightbox() {
    if (!recipeLightbox) return;
    recipeLightbox.classList.remove('is-open');
    document.body.style.overflow = '';
    if (recipeLastFocus && recipeLastFocus.focus) recipeLastFocus.focus();
    setTimeout(function () {
      if (!recipeLightbox.classList.contains('is-open')) $('img', recipeLightbox).removeAttribute('src');
    }, reduceMotion ? 0 : 300);
  }

  /* Full recipe overlay. Every recipe is pre-rendered hidden inside the
     section, so opening one is a show/hide — no fetching, no cloning, and the
     card and full view keep independent basket selections. */
  var recipeOpenPanel = null, recipeOpenLastFocus = null;
  var FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

  function openRecipePanel(id, updateHash) {
    var panel = document.querySelector('[data-rcp-panel="' + (window.CSS && CSS.escape ? CSS.escape(id) : id) + '"]');
    if (!panel) return false;
    if (recipeOpenPanel) closeRecipePanel(false);

    var overlay = panel.closest('[data-rcp-overlay]');
    recipeOpenLastFocus = document.activeElement;
    overlay.hidden = false;
    panel.hidden = false;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    recipeOpenPanel = panel;

    var scroll = $('.rfull__scroll', panel);
    if (scroll) scroll.scrollTop = 0;

    var closeBtn = $('[data-rcp-close]', panel);
    if (closeBtn) closeBtn.focus();

    if (updateHash !== false && id) {
      history.replaceState(null, '', '#recipe-' + id);
    }
    return true;
  }

  function closeRecipePanel(clearHash) {
    if (!recipeOpenPanel) return;
    var panel = recipeOpenPanel;
    var overlay = panel.closest('[data-rcp-overlay]');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    recipeOpenPanel = null;

    var finish = function () {
      panel.hidden = true;
      if (!overlay.classList.contains('is-open')) overlay.hidden = true;
    };
    if (reduceMotion) finish(); else setTimeout(finish, 260);

    if (recipeOpenLastFocus && recipeOpenLastFocus.focus) recipeOpenLastFocus.focus();
    if (clearHash !== false && window.location.hash.indexOf('#recipe-') === 0) {
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  }

  function trapRecipeFocus(e) {
    var items = $$(FOCUSABLE, recipeOpenPanel).filter(function (el) { return el.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function initRecipes() {
    $$('[data-rcp-shop]').forEach(syncRecipeShop);
    // Landing on /pages/recipes#recipe-x opens that recipe straight away.
    if (!recipeOpenPanel && window.location.hash.indexOf('#recipe-') === 0) {
      openRecipePanel(window.location.hash.slice('#recipe-'.length), false);
    }
  }

  function initRecipeEvents() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-rcp-open]');
      if (opener) { e.preventDefault(); openRecipePanel(opener.dataset.rcpOpen); return; }

      if (e.target.closest('[data-rcp-close]')) { closeRecipePanel(); return; }

      var check = e.target.closest('[data-rcp-check]');
      if (check) {
        check.setAttribute('aria-pressed', check.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        return;
      }
      var toggle = e.target.closest('[data-rcp-toggle]');
      if (toggle) {
        var on = toggle.getAttribute('aria-pressed') === 'true';
        toggle.setAttribute('aria-pressed', on ? 'false' : 'true');
        toggle.closest('[data-rcp-product]').classList.toggle('is-excluded', on);
        var shop = toggle.closest('[data-rcp-shop]');
        if (shop) syncRecipeShop(shop);
        return;
      }
      var tile = e.target.closest('[data-rcp-tile]');
      if (tile) openRecipeLightbox(tile);
    });

    document.addEventListener('keydown', function (e) {
      if (recipeOpenPanel) {
        if (e.key === 'Escape') { closeRecipePanel(); return; }
        if (e.key === 'Tab') { trapRecipeFocus(e); return; }
      }
      var tile = e.target.closest && e.target.closest('[data-rcp-tile]');
      if (tile && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); openRecipeLightbox(tile); return; }
      if (!recipeLightbox || !recipeLightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeRecipeLightbox();
      else if (e.key === 'ArrowRight') showRecipeLightbox(recipeIndex + 1);
      else if (e.key === 'ArrowLeft') showRecipeLightbox(recipeIndex - 1);
      else if (e.key === 'Tab') { e.preventDefault(); $('[data-rcp-lb-close]', recipeLightbox).focus(); }
    });

    // A #recipe-x link pointing at the page you're already on changes the hash
    // without reloading, so DOMContentLoaded never fires again — open it here.
    window.addEventListener('hashchange', function () {
      var hash = window.location.hash;
      if (hash.indexOf('#recipe-') === 0) openRecipePanel(hash.slice('#recipe-'.length), false);
      else if (recipeOpenPanel) closeRecipePanel(false);
    });
  }

  /* ---------- Video facades ----------
     A poster image stands in for the embed until it's clicked, so YouTube's
     player (and its cookies) never load for visitors who don't press play. */
  function initVideoFacades() {
    document.addEventListener('click', function (e) {
      var facade = e.target.closest('[data-video-facade]');
      if (!facade) return;
      var src = facade.dataset.videoSrc;
      if (!src) return;
      var frame = document.createElement('iframe');
      frame.src = src;
      frame.title = facade.dataset.videoTitle || 'Video';
      frame.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
      frame.setAttribute('allowfullscreen', '');
      frame.setAttribute('loading', 'lazy');
      var wrap = document.createElement('div');
      wrap.className = facade.className.replace('about__video-facade', '').trim();
      wrap.appendChild(frame);
      facade.replaceWith(wrap);
      frame.focus();
    });
  }

  /* ---------- Init ---------- */
  document.addEventListener('shopify:section:load', function () {
    initReveals();
    initRecipes();
  });

  document.addEventListener('DOMContentLoaded', function () {
    initReveals();
    initRecipes();
    initRecipeEvents();
    initVideoFacades();
    initHeader();
    initDrawers();
    initCart();
    initProductForms();
    initGallery();
    initQuickView();
    initStickyAtc();
    initAnnouncement();
    initPredictiveSearch();
    initFacets();
  });

  window.Hasad = window.Hasad || {};
  window.Hasad.openDrawer = openDrawer;
  window.Hasad.closeDrawers = closeDrawers;
  window.Hasad.toast = toast;
  window.Hasad.formatMoney = formatMoney;
  window.Hasad.initReveals = initReveals;
})();
